import { VersionedArtifactTypeGroup } from '../../resource/enumerations/VersionedArtifactTypeGroup';
import { ValidationScopes, ValidationScopeType } from '../../resource/resource-base/types';
import { RootState } from '../../store/rootReducer';

export const selectIsDirty = (state: RootState) => state.ui.status.isDirty;

export const selectReadOnly = (state: RootState) => state.persisted.global.readonly;

export const selectValidationScopeBasedOnVersionedParent = (
    state: RootState,
    versionedInArtifactTypeGroup: VersionedArtifactTypeGroup | undefined
): ValidationScopes => {
    return selectNoScopeValidationScope(state);
};

// TODO this should be a constant object
export const selectNoScopeValidationScope = (_state: RootState): ValidationScopes => ({
    validationScopes: [
        {
            type: ValidationScopeType.NO_SCOPE,
        },
    ],
});

// TODO Somehow make this automatically
export const isBackgroundProcessInProgress = (state: RootState) => {
    return state.ui.status.mutationInProgress;
};
